// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__kkdTe","full":"index_full__2kDAi","img":"index_img__JGOll","title":"index_title__2rHpr","props":"index_props__13igw","desc":"index_desc__3qRIC"};